import { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import WebcamRecorder from "./webCam";
import axios from "axios";
import FaceCalibration from "./Calibration";
import { useSearchParams } from "react-router-dom";
import toast from "react-hot-toast";
import bgImage from "../../../assets/images/bg-img.jpg";
import MCQInterviewPage from "./McqInterview";
import CodeEditor from "./CodingInterview";
import QuestionAnswerOral from "./QuestionAnswerOral";
import { useInterview } from "../../../services/InterviewProgressContext";

const InterviewVideoCallPage = () => {
  /**
   * Context for the step of the interview
   */
  const { currentStep, nextStep } = useInterview();
  const [question, setQuestions] = useState();
  const [mcqCompleted, setMcqCompleted] = useState(false);
  const [name, setName] = useState("");
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const candidateID = searchParams.get("candidate_id");
  const [loading, setLoading] = useState(false);
  const [recording, setRecording] = useState(false);
  const [countdown, setCountdown] = useState(30);
  const [videoUrl, setVideoUrl] = useState(null);
  const [startVideo, setStartVideo] = useState(false);
  const isStoppingVideo = useRef(false);
  const isCameraAllowedRef = useRef(true);
  const retryCountRef = useRef(0);

  const videoRef = useRef(null);
  const handleRelisten = () => {
    if (videoRef.current) {
      videoRef.current.currentTime = 0;
      videoRef.current.play();
    }
  };

  const profilePhoto = async () => {
    setLoading(true);
    try {
      const record = await axios.get(
        `${process.env.REACT_APP_API_KEY}/capture_profile_photo?jd_id=${id}&candidate_id=${candidateID}`,
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      toast.success("Profile photo captured successfully!", {
        style: { backgroundColor: "green", color: "white" },
      });
      setLoading(false);
    } catch (error) {
      toast.error("Failed to capture profile photo.", {
        style: { backgroundColor: "red", color: "white" },
      });
    }
  };

  useEffect(() => {
    console.log(videoUrl, "videoUrl");
  }, [videoUrl]);

  return (
    <>
      {currentStep === "main" && (
        <motion.div
          className="flex items-center justify-center h-screen"
          style={{
            height: "calc(100vh - 95px)",
            backgroundImage: `url(${bgImage})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="text-white flex items-center space-x-4 bg-white/10 backdrop-blur-md px-6 py-4 rounded-lg shadow-lg w-10/12 justify-between"
          >
            <div className="flex items-center gap-2">
              <motion.i
                className="fa fa-robot text-4xl"
                initial={{ x: -20, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.8, delay: 0.2 }}
              ></motion.i>

              <motion.p
                className="text-xl font-semibold"
                initial={{ y: -10, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.8, delay: 0.4 }}
              >
                Welcome to your interview
              </motion.p>
            </div>

            <motion.button
              className="px-5 py-2 text-lg font-medium text-white bg-blue-600 rounded-full shadow-md hover:bg-blue-700 transition-transform transform hover:scale-105"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => nextStep()}
            >
              Start
            </motion.button>
          </motion.div>
        </motion.div>
      )}

      {(currentStep == "startInterview" ||
        currentStep == "mcqs" ||
        currentStep == "oralQuestions" ||
        currentStep == "codingQuestions" ||
        currentStep == "completed" ||
        currentStep == "reportGenerated") && (
        <motion.div
          className="px-6  pt-6 pb-10 min-h-[calc(100vh-80px)]"
          style={{
            backgroundImage: `url(${bgImage})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="grid grid-cols-12 w-full h-full gap-4">
            {currentStep == "codingQuestions" ||
            currentStep == "completed" ||
            currentStep == "reportGenerated" ? (
              <>
                {/* CodeEditor on the Left */}
                <div
                  className={`${
                    currentStep == "completed" || currentStep == "reportGenerated"
                      ? "col-span-12 h-[calc(100vh-130px)] flex justify-center items-center"
                      : "col-span-8 h-full"
                  } flex flex-col  w-full rounded-lg shadow-lg overflow-hidden`}
                >
                  <CodeEditor
                    isStoppingVideo={isStoppingVideo}
                    currentStep={currentStep}
                  />
                </div>

                {/* WebcamRecorder on the Right */}
                {(currentStep != "completed" ||
                  currentStep != "reportGenerated") && (
                  <div className="col-span-4 w-full">
                    <WebcamRecorder
                      isCameraAllowedRef={isCameraAllowedRef}
                      startVideo={startVideo}
                      setStartVideo={setStartVideo}
                      isStoppingVideo={isStoppingVideo}
                      mcqCompleted={mcqCompleted}
                      retryCountRef={retryCountRef}
                      currentStep={currentStep}
                    />
                  </div>
                )}
              </>
            ) : (
              <>
                {/* Default Layout with WebcamRecorder on the Left */}
                <div className="col-span-8 w-full">
                  <WebcamRecorder
                    setQuestions={setQuestions}
                    mcqQuestionsCompleted={mcqCompleted}
                    recording={recording}
                    setRecording={setRecording}
                    countdown={countdown}
                    setCountdown={setCountdown}
                    setVideoUrl={setVideoUrl}
                    handleRelisten={handleRelisten}
                    isCameraAllowedRef={isCameraAllowedRef}
                    setStartVideo={setStartVideo}
                    isStoppingVideo={isStoppingVideo}
                    retryCountRef={retryCountRef}
                    currentStep={currentStep}
                  />
                </div>

                {/* MCQ Section */}
                {currentStep == "mcqs" && (
                  <div className="col-span-4 flex flex-col items-center gap-4">
                    <MCQInterviewPage
                      setMcqQuestionsCompleted={setMcqCompleted}
                      currentStep={currentStep}
                    />
                  </div>
                )}

                {/* Question Answer Section */}
                {currentStep == "oralQuestions" && (
                  <QuestionAnswerOral
                    question={question}
                    recording={recording}
                    countdown={countdown}
                    videoUrl={videoUrl}
                    videoRef={videoRef}
                    currentStep={currentStep}
                  />
                )}
              </>
            )}
          </div>
        </motion.div>
      )}

      {(currentStep == "profilePicture" ||
        currentStep == "faceCalibration") && (
        <div className="flex justify-center h-[calc(100vh-130px)] relative w-full">
          <FaceCalibration
            profilePhoto={profilePhoto}
            name={name}
            setName={setName}
            loading={loading}
            setLoading={setLoading}
            currentStep={currentStep}
          />
        </div>
      )}
    </>
  );
};

export default InterviewVideoCallPage;
